// @ts-nocheck

import { send, connected, disconnected, reconnect, recv } from '../actions/network';
import { NetworkActionTypes } from '../types/actions/network';
import { NetworkStatuses } from '../types/network';
import { Routes } from '../types/routes';
import { SocketEvents } from '../types/socket';
import dispatcher from '../utils/dispatcher';
import { buildMessageBasketFromData } from '../utils/message';

const logError = (payload) => {
  console.debug(
    `%c → ${NetworkActionTypes.SEND} | ${Object.keys(payload).join(' / ')} %O`,
    'background: #b20e10; color: #fff;',
    payload,
  );
};

const logInfo = (payload) => {
  console.debug(
    `%c → ${NetworkActionTypes.SEND} ${Object.keys(payload).join(' / ')} %O`,
    'background: rgb(26, 115, 232); color: #fff;',
    payload,
  );
};

const logSuccess = (payload) => {
  console.debug(
    `%c ← ${NetworkActionTypes.RECV} ${Object.keys(payload).join(' / ')} %O`,
    'background: #3f8c42; color: #fff;',
    payload,
  );
};

// Action type pattern matching
const ActionTypePattern = 'socket/';

// Last call route
let currentRoute = null;
let queue = [];

const initSocket = (socket, { state, dispatch, store }) => {
  socket.on(SocketEvents.CONNECT, () => {
    let initRequest = {};
    const stateCC = store.getState().user.cc;
    const cc = stateCC ? stateCC : global.getSessionId?.() ?? null;

    // Ask for account related information if connected
    if (cc) {
      initRequest.cc = cc;
    }

    // Ask for menu
    initRequest.menu = true;

    // Ask for the current route
    if (currentRoute) {
      const { requestId, route, ...rest } = currentRoute.payload;
      if (route === Routes.MULTIVIEW) {
        const {
          multiview: { list },
        } = state;
        initRequest = { route, multiMatches: list, data: true, ...initRequest };
      } else if (route === Routes.HISTORY) {
        if (cc) {
          initRequest = { requestId, route, ...rest, data: true, ...initRequest };
        }
      } else {
        initRequest = { requestId, route, data: true, ...initRequest };
      }
    }

    // Ask for entities related to basket
    const { basket } = buildMessageBasketFromData(state);

    if (basket.matches.length) {
      initRequest = { ...initRequest, basket, data: true };
    }

    queue.push(send(initRequest));

    // Update network status
    dispatch(connected);
  });

  socket.on(SocketEvents.CONNECT_ERROR, () => {
    dispatch(disconnected);
  });

  socket.on(SocketEvents.RECONNECTING, () => {
    dispatch(reconnect);
  });

  socket.on(SocketEvents.DISCONNECT, () => {
    dispatch(disconnected);
  });

  socket.on(SocketEvents.MESSAGE, (message) => {
    dispatch(recv(message));
  });
};

const handleAction =
  ({ socket, store, history }) =>
  (next) =>
  (action) => {
    const state = store.getState();
    const {
      runtime,
      network: networkStatus,
      user: { connected: isUserConnected },
    } = state;
    const { payload } = action;

    if (action.type.match(ActionTypePattern)) {
      const returnValue = next(action);

      switch (action.type) {
        case NetworkActionTypes.CONNECTED:
          if (queue.length) {
            queue.reverse();
            while (queue.length) {
              const queuedAction = queue.pop();
              store.dispatch(queuedAction);
            }
          }
          break;

        case NetworkActionTypes.CONNECT: {
          const { licence } = runtime;
          socket.createNewConnection(licence);
          break;
        }

        case NetworkActionTypes.CLOSE:
          socket.disconnect();
          queue = [];
          break;

        case NetworkActionTypes.RECV:
          logSuccess(payload);
          dispatcher(store, payload, history);
          break;

        case NetworkActionTypes.SEND:
          if (payload.route) {
            currentRoute = action;
          }

          if (networkStatus === NetworkStatuses.CONNECTED) {
            let isOk = true;

            if ('meta' in action) {
              if (action.meta.auth && !isUserConnected) {
                isOk = false;
                logError(payload);
              }
            }

            if (isOk) {
              socket.emit(SocketEvents.MESSAGE, payload);
              logInfo(payload);
            }
          }
          break;

        default:
          break;
      }
      return returnValue;
    }
    return next(action);
  };

const networkMiddleware = (socket, history) => (store) => {
  const initialState = store.getState();
  const { dispatch } = store;

  initSocket(socket, { state: initialState, dispatch, store });

  return handleAction({ socket, store, history });
};

export default networkMiddleware;
